import React, { FunctionComponent, MouseEventHandler } from "react";

import { QAProps, TabIndex } from "@multiweb/types/react";
import { ComponentTheme } from "@multiweb/uiShared/ComponentTheme";
import { ButtonBackgroundColor, ButtonProvider, ButtonProviderProps } from "../ButtonProvider";
import { Text, TextColor, WhiteSpace } from "../Text";
import { TextButtonSpacing } from "../TextButtonSpacing";
import { ComponentSize } from "../types";

export type SelectTextButtonProps = {
    /** Příznak, zda je tlačítko zakázané */
    disabled?: boolean;
    /** Callback volaný na kliknutí */
    onClick: MouseEventHandler<HTMLButtonElement>;
    /** Text zobrazený na tlačítku */
    text?: string;
    /** Popisek zobrazený po najetí myši */
    title?: string;
    /** Umožňuje nastavit tabindex - výchozí hodnota je undefined, chování tedy závisí na prohlížeči */
    tabIndex?: TabIndex;
    /** Příznak, zda je komponenta zaměřená */
    isFocused?: boolean;
} & QAProps & Pick<ButtonProviderProps, "shadow" | "outline" | "backgroundColor">;

/** Komponenta tlačítka pro otevírání rozevíracího seznamu */
export const SelectTextButton: FunctionComponent<SelectTextButtonProps> = ({
    disabled = false,
    onClick,
    text,
    backgroundColor = ButtonBackgroundColor.transparent,
    title,
    tabIndex,
    shadow,
    outline,
    isFocused = false,
    qa,
}) => (
    <ButtonProvider
        theme={ComponentTheme.default}
        {...{ onClick, disabled, title, backgroundColor, tabIndex, isFocused, qa, shadow, outline }}
    >
        <TextButtonSpacing size={ComponentSize.large}>
            <Text
                isTextSelectable={false}
                whiteSpace={WhiteSpace.nowrap}
                value={text}
                theme={ComponentTheme.default}
                color={TextColor.textSecondary}
                {...{ disabled }}
            />
        </TextButtonSpacing>
    </ButtonProvider>
);
